export default "__VITE_ASSET__CSEVGPKg__"